import { render, staticRenderFns } from "./NewProjectForumThread.vue?vue&type=template&id=005aa3bb&scoped=true"
import script from "./NewProjectForumThread.vue?vue&type=script&lang=ts"
export * from "./NewProjectForumThread.vue?vue&type=script&lang=ts"
import style0 from "./NewProjectForumThread.vue?vue&type=style&index=0&id=005aa3bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005aa3bb",
  null
  
)

export default component.exports